
import { GameState } from '../../GameContextTypes';

// Calculate base experience gain based on career level
export const calculateYearlyExperienceGain = (
  careerLevel: string, 
  yearsPassed: number,
  kpis: GameState['kpis']
) => {
  // Base experience by career level
  const baseExperienceByLevel = {
    'Junior': 10,
    'Mid-Level': 15,
    'Senior': 25,
    'Leader': 40,
    'Expert': 50
  };
  
  let experienceGain = baseExperienceByLevel[careerLevel] || 10;
  
  // Experience bonus from high KPI values
  if (kpis.uptime > 98) experienceGain += 5;
  if (kpis.energyCost < 0.04) experienceGain += 5;
  if (kpis.profitMargin > 35) experienceGain += 5;
  if (kpis.efficiency > 90) experienceGain += 5;
  
  // Years passed factor - later years give slightly less experience
  const yearsFactor = Math.max(0.8, 1 - (yearsPassed * 0.01));
  return Math.round(experienceGain * yearsFactor);
};
